// extracted by mini-css-extract-plugin
export var pillWrapper = "_lf-0";
export var showOverflow = "_lf-1";